/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const informationSecurityCybersecurityEnumsIncidentAffectsACustomerOptionEnum = {
    Yes: 'Yes',
    No: 'No',
    CannotSpecify: 'CannotSpecify',
} as const;

export type InformationSecurityCybersecurityEnumsIncidentAffectsACustomerOptionEnumKey =
    (typeof informationSecurityCybersecurityEnumsIncidentAffectsACustomerOptionEnum)[keyof typeof informationSecurityCybersecurityEnumsIncidentAffectsACustomerOptionEnum];

export type InformationSecurityCybersecurityEnumsIncidentAffectsACustomerOption =
    InformationSecurityCybersecurityEnumsIncidentAffectsACustomerOptionEnumKey;
